import {
  canChiNgay,
  diaChi,
  ngayThangNam,
  ngayThangNamCanChi,
  nguHanh,
  nguHanhNapAm,
  sinhKhac,
  thienCan,
  timCuc
} from './amduong'
import { jdn } from '../calender'

export class LapThienBan {
  constructor (nn, tt, nnnn, gioSinh, gioiTinh, ten, diaBan) {
    this.gioiTinh = gioiTinh === 1 ? 1 : -1
    this.namNu = gioiTinh === 1 ? 'Nam' : 'Nữ'
    var chiGioSinh = diaChi[gioSinh]
    var canGioSinh = ((jdn(nn, tt, nnnn) - 1) * 2 % 10 + gioSinh) % 10
    if (canGioSinh === 0) {
      canGioSinh = 10
    }
    this.chiGioSinh = chiGioSinh
    this.gioSinh = thienCan[canGioSinh].tenCan + ' ' + chiGioSinh.tenChi

    this.canNamXem = diaBan.canchiNamXem[2]
    this.chiNamXem = diaBan.canchiNamXem[3]
    this.curYear = diaBan.curYear
    this.namXem = thienCan[this.canNamXem].tenCan + ' ' + diaChi[this.chiNamXem].tenChi
    this.daiHanXem = diaBan.thapNhiCung[diaBan.daiHanXem] && diaBan.thapNhiCung[diaBan.daiHanXem].cungDaiHan

    this.ngayDuong = nn
    this.thangDuong = tt
    this.namDuong = nnnn
    this.ten = ten

    var lunar = ngayThangNam(this.ngayDuong, this.thangDuong, this.namDuong)
    this.ngayAm = lunar.day
    this.thangAm = lunar.month
    this.namAm = lunar.year

    var [canThang, chiThang, canNam, chiNam] = ngayThangNamCanChi(this.ngayDuong, this.thangDuong, this.namDuong)
    this.canThang = canThang
    this.canNam = canNam
    this.chiNam = chiNam

    this.canThangTen = thienCan[this.canThang].tenCan
    this.canNamTen = thienCan[this.canNam].tenCan
    this.chiThangTen = diaChi[chiThang].tenChi
    this.chiNamTen = diaChi[this.chiNam].tenChi

    var [canNgay, chiNgay] = canChiNgay(this.ngayDuong, this.thangDuong, this.namDuong)
    this.canNgay = canNgay
    this.chiNgay = chiNgay

    this.canNgayTen = thienCan[this.canNgay].tenCan
    this.chiNgayTen = diaChi[this.chiNgay].tenChi

    var cungAmDuong = diaBan.cungMenh % 2 === 1 ? 1 : -1
    this.amDuongNamSinh = this.chiNam % 2 === 1 ? 'Dương' : 'Âm'
    this.amDuongNamNu = thienCan[this.canNam].amDuong * this.gioiTinh
    if (cungAmDuong * this.gioiTinh === 1) {
      this.amDuongMenh = 'Âm Dương thuận lý'
    } else {
      this.amDuongMenh = 'Âm Dương nghịch lý'
    }

    var cuc = timCuc(diaBan.cungMenh, this.canNam)
    this.hanhCuc = nguHanh(cuc).id
    this.tenCuc = nguHanh(cuc).tenCuc

    this.menhChu = diaChi[diaBan.cungMenh].menhChu
    this.thanChu = diaChi[this.chiNam].thanChu

    this.menh = nguHanhNapAm(this.chiNam, this.canNam)
    var menhId = nguHanh(this.menh).id
    var menhCuc = sinhKhac(menhId, this.hanhCuc)

    if (menhCuc === 1) {
      this.sinhKhac = 'Mệnh sinh Cục'
    } else if (menhCuc === -1) {
      this.sinhKhac = 'Mệnh khắc Cục'
    } else if (menhCuc === -2) {
      this.sinhKhac = 'Cục khắc Mệnh'
    } else if (menhCuc === 2) {
      this.sinhKhac = 'Cục sinh Mệnh'
    } else {
      this.sinhKhac = 'Cục hòa Mệnh'
    }

    this.banMenh = nguHanhNapAm(this.chiNam, this.canNam, true)
    this.thanCu = 'Thân cư ' + diaBan.thapNhiCung[diaBan.cungThan].cungChu
  }
}
